import styled, { css } from 'styled-components';
import styledContainerQuery from 'styled-container-query';
import { Typography } from 'src/typography';

export const TabHeader = styled.div<{ firstTabSelected: boolean }>`
  display: flex;
  align-items: center;
  align-self: stretch;
  position: relative;
  height: 65px;
  gap: 32px;
  margin-bottom: 24px;
  @media screen and (max-width: 600px) {
    gap: 10px;
    overflow-x: auto;
    flex-wrap: nowrap;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const Tab = styled.button<{ selected: boolean }>`
  ${({ theme: { spaces }, selected, display }) => css`
    display: flex;
    min-height: 55px;
    padding: 0 ${spaces[1]} 0 0;
    align-items: left;
    align-content: center;
    flex-wrap: wrap;
    position: relative;
    cursor: pointer;
    border-bottom: 2px solid ${selected ? 'var(--dcm-color-primary)' : 'var(--dcm-color-text-inverted)'};
    color: ${selected ? 'var(--dcm-color-primary)' : 'var(--dcm-color-text-secondary)'};
    border-top: none;
    border-left: none;
    border-right: none;
    background: none;
    display: ${display ? 'flex' : 'none'};
    @media screen and (max-width: 600px) {
      border-bottom: none;
      flex-shrink: 0;
    }
  `}
`;

export const TabText = styled<{ selected: boolean }>(Typography.Body)`
  line-height: 20px;
  color: ${({ selected }) => (selected ? 'var(--dcm-color-primary)' : 'var(--dcm-color-text-secondary)')};
  @media screen and (max-width: 600px) {
    white-space: nowrap;
    border-radius: var(--dcm-radius-md);
    padding: 8px 20px;
    color: ${({ selected }) => (selected ? 'var(--dcm-color-text-inverted)' : 'var(--dcm-color-text-secondary)')};
    background-color: ${({ selected }) =>
      selected ? 'var(--dcm-color-primary)' : 'var(--dcm-referral-tab-inactive-bg)'};
  }
`;

export const TabsContainer = styled.div`
  transition: background-color 300ms ease;
`;

export const RewardsContainer = styledContainerQuery.div`
  &:container(min-width: 600px) {
    padding: 0;
  }
  &:container(min-width: 900px) {
    padding: 48px 64px;
  }
`;
